import searchIcon from './../../link-modal/images/search-icon.svg';
import closeIcon from './../../link-modal/images/close-icon.svg';
import Loader from './3-dots-fade.svg';
import ErrorIcon from './error-icon.svg';
const modalView = ({ searchPlaceholder }) => `
  <div class="link-modal-overlay">
    <div class="link-modal">
      <div class="link-modal__search">
        <div class="link-modal__search-field">
          <div class="link-modal__search-icon">${searchIcon}</div>
          <input type="text" class="link-modal__search-input" placeholder="${searchPlaceholder || 'Resume template title'}..." autofocus disabled />
        </div>
        <div class="link-modal__close">${closeIcon}</div>
      </div>
      <div class="state-container"></div>
      <div class="resume-example-container"></div>
      <div class="link-modal__footer">
        <div class="link-modal__footer-message">Press Esc to exit</div>
      </div>
    </div>
  </div>
`;
const resumeExampleItem = (resume) => {
    return `
    <div class="link-modal__publication resume-example_item ${resume[2] ? 'taken' : ''}" data-text='#${resume[1]} ${resume[0]}'>
      <div class="link-modal__publication-title ">#${resume[1]} ${resume[0]}</div>
    </div>
  `;
};
const resumeExampleUserItem = (resume) => {
    return `
    <div class="resume-example_user" data-text='${resume}'>
      <div class="link-modal__publication-title">${resume}</div>
    </div>
  `;
};
class ResumeExampleModal {
    constructor(modalViewParams) {
        this.modalView = modalView(modalViewParams || {});
        this.resumes = [];
        this.takenResumes = [];
        this.mappedResumes = {};
    }
    handleItemClick(resume) {
        this.onSelect(resume);
        this.hide();
    }
    showResumeExample(resumes) {
        this.resumeExampleContainer.classList.add('is-visible');
        this.resumeExampleContainer.innerHTML = '';
        const appendResume = (container, resume, resumeUser) => {
            container.insertAdjacentHTML('beforeend', resumeExampleItem(resume));
            const items = container.children;
            items[items.length - 1].addEventListener('click', () => {
                this.handleItemClick({ resume, resumeUser });
            });
        };
        const appendResumeUser = (container, resumeUser) => {
            container.insertAdjacentHTML('beforeend', resumeExampleUserItem(resumeUser));
        };
        Object.keys(resumes).forEach((resumeKey) => {
            appendResumeUser(this.resumeExampleContainer, resumeKey);
            resumes[resumeKey].forEach((resume) => appendResume(this.resumeExampleContainer, resume, resumeKey));
        });
    }
    show() {
        document.body.insertAdjacentHTML('afterbegin', this.modalView);
        document.body.style.overflowY = 'hidden';
        this.textField = document.querySelector('.link-modal__search-input');
        this.closeButton = document.querySelector('.link-modal__close');
        this.stateContainer = document.querySelector('.state-container');
        this.modalContainer = document.querySelector('.link-modal-overlay');
        this.resumeExampleContainer = document.querySelector('.resume-example-container');
        this.addHandlers();
        this.loadResumes();
        return new Promise((resolve, reject) => {
            this.onSelect = resolve;
            this.onClose = reject;
        });
    }
    hide() {
        document.body.removeChild(this.modalContainer);
        document.body.style.overflowY = 'auto';
    }
    handleCloseClick(e) {
        e.stopPropagation();
        this.hide();
    }
    handleEscapeClick(e) {
        if (e.code === 'Escape')
            this.handleCloseClick(e);
    }
    addHandlers() {
        let debounce;
        this.closeButton.addEventListener('click', this.handleCloseClick.bind(this));
        this.modalContainer.addEventListener('keyup', this.handleEscapeClick.bind(this));
        this.textField.addEventListener('keyup', (event) => {
            clearTimeout(debounce);
            debounce = window.setTimeout(() => {
                this.handleTextFieldChange(event);
            }, 200);
        });
    }
    handleTextFieldChange(event) {
        const value = event.target.value.trim().toLowerCase();
        let filteredResumes = structuredClone(this.mappedResumes);
        if (!value) {
            this.showResumeExample(filteredResumes);
            return;
        }
        let resumesToShow = {};
        for (const resumeKey in filteredResumes) {
            resumesToShow = {
                ...resumesToShow,
                [resumeKey]: filteredResumes[resumeKey].filter((resume) => `#${resume[1]} ${resume[0]}`.toLowerCase().includes(value)),
            };
        }
        const arrayOfKeyValuePairsOfResumesToShow = Object.entries(resumesToShow);
        arrayOfKeyValuePairsOfResumesToShow.sort((a, b) => b[1].length - a[1].length);
        const sortedResumesToShow = Object.fromEntries(arrayOfKeyValuePairsOfResumesToShow);
        this.showResumeExample(sortedResumesToShow);
    }
    showState(container, stateView) {
        container.classList.add('is-visible');
        container.innerHTML = '';
        container.insertAdjacentHTML('beforeend', stateView);
    }
    hideState(container) {
        container.classList.remove('is-visible');
        container.innerHTML = '';
    }
    loadResumes() {
        this.showState(this.stateContainer, `${Loader}<span>Fetching Example Resumes...</span>`);
        // @TODO remove hardcoded api url
        fetch('/api/ckeditor/fetch-associated-examples', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                selected_example_type: 'resume',
            }),
        })
            .then((res) => {
            res.json().then(({ data }) => {
                this.resumes = data.sources;
                this.takenResumes = data.taken_ids;
                for (const resumeKey in data.sources) {
                    this.mappedResumes = {
                        ...this.mappedResumes,
                        [resumeKey]: data.sources[resumeKey].map((resume) => [
                            ...resume,
                            data.taken_ids.includes(resume[1]),
                        ]),
                    };
                }
                this.hideState(this.stateContainer);
                this.showResumeExample(this.mappedResumes);
                this.textField.removeAttribute('disabled');
                this.textField.focus();
            });
        })
            .catch((error) => {
            console.error(error);
            this.showState(this.stateContainer, `${ErrorIcon}<span>Something went wrong!!</span>`);
        });
    }
}
export default ResumeExampleModal;
